import React from 'react'
import {Lang} from 'yougile-lang'
import {DataObjectId} from 'yougile-model'
import {UserStickerState} from '../../../extensions/sticker/views-web/user/user-sticker-state'
import {CrmActivitiesFilters, CrmActivitiesView} from '../common'
import {DealViewDateFilter} from './deal-view-date-filter'
import {DealViewFilterSwitcher} from './deal-view-filter-switcher'

interface DealViewFiltersProps {
  filters: CrmActivitiesFilters
  setFilters: (filters: CrmActivitiesFilters) => void
  activitiesView: CrmActivitiesView
  className?: string
}

export const DealViewFilter = (props: DealViewFiltersProps) => {
  const {filters, setFilters, activitiesView, className} = props

  return (
    <div className={className}>
      <div className="flex items-center w-full mb-24 flex-wrap row-gap-8 gap-12">
        <DealViewFilterSwitcher
          filters={filters}
          setFilters={setFilters}
          activitiesView={activitiesView}
        />

        <div className="flex items-center cursor-pointer">
          <UserStickerState
            avatarsClassName="flex items-center"
            users={filters.assigned ?? []}
            options={activitiesView.projectUsersIds ?? []}
            childrenClassName={'!gap-8'}
            showIcon
            showEmptyIcon
            onChoose={(assigned: DataObjectId[]) => {
              setFilters({
                ...filters,
                assigned
              })
            }}
            maxShow={5}
            title={Lang.msg.assigned}
            size={16}
          >
            <div className="text-sm-regular text-secondary">
              {Lang.msg.crm.activitiesView.filterByAssigned}
            </div>
          </UserStickerState>
        </div>
      </div>

      <DealViewDateFilter
        filters={filters}
        setFilters={setFilters}
        activitiesView={activitiesView}
      />
    </div>
  )
}
